var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabledExtensions.length !== 0)?_c('div',[_vm._l((_vm.enabledExtensions),function(extension){return [_c(extension.name,{tag:"component",attrs:{"settings":_vm.entity}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }